<template>
  <div class="r-order-details" ref="printMe">
    <!-- 步骤条 -->
    <div class="steps common-flex common-justify-center" v-if="!hideStep">
      <div
        class="common-flex common-align-center"
        v-for="(item, index) in step"
        :key="index"
      >
        <div
          class="step-line"
          :style="[stepId >= item.id ? { background: '#0A4DCC' } : {}]"
          v-if="index != 0"
        ></div>
        <div class="step-radio">
          <div :class="stepId >= item.id ? 'step-radio-check' : ''">
            {{ item.id }}
          </div>
          <div class="step-status">
            <div class="step-name">{{ item.name }}</div>
            <div class="step-value" v-if="stepId >= item.id">
              {{ item.value }}
            </div>
          </div>
        </div>
        <div
          class="step-line"
          :style="[stepId >= item.id ? { background: '#0A4DCC' } : {}]"
          v-if="index != step.length - 1"
        ></div>
      </div>
    </div>
    <!-- 订单详情 -->
    <!-- 公共部分 -->
    <div v-if="false" class="detail-msg common-flex common-align-center">
      <div style="padding-left: 0">
        <div class="detail-msg-title">
          {{ $t("order.consigneeInformation") }}
        </div>
        <div class="detail-content common-flex common-justify-between">
          <div class="label">{{ $t("order.onsignee") }}</div>
          <div class="value">Joel Jackson</div>
        </div>
        <div class="detail-content common-flex common-justify-between">
          <div class="label">{{ $t("order.phone") }}</div>
          <div class="value">-</div>
        </div>
        <div class="detail-content common-flex common-justify-between">
          <div class="label">{{ $t("order.address") }}</div>
          <div class="value">
            3050 Bowers Avenue P.O. Box 58039 Santa Clara, CA 95054-3299 U.S.A.
          </div>
        </div>
      </div>
      <div>
        <div class="detail-msg-title">
          {{ $t("order.consigneeInformation") }}
        </div>
        <div class="detail-content common-flex common-justify-between">
          <div class="label">{{ $t("order.deliveryMethod") }}</div>
          <div class="value">Joel Jackson</div>
        </div>
        <div class="detail-content common-flex common-justify-between">
          <div class="label">{{ $t("order.deliveryNo") }}</div>
          <div class="value">Joel Jackson</div>
        </div>
        <div class="detail-content common-flex common-justify-between">
          <div class="label">{{ $t("order.freight") }}</div>
          <div class="value">Joel Jackson</div>
        </div>
      </div>
      <div style="border: none; padding-right: 0">
        <div class="detail-msg-title">
          {{ $t("order.consigneeInformation") }}
        </div>
        <div class="detail-content common-flex common-justify-between">
          <div class="label">{{ $t("order.paymentMethod") }}</div>
          <div class="value">Virtual account</div>
        </div>
        <div class="detail-content common-flex common-justify-between">
          <div class="label">{{ $t("order.paymentTime") }}</div>
          <div class="value">2020-07-18 09:01:00</div>
        </div>
        <div class="detail-content common-flex common-justify-between">
          <div class="label">{{ $t("order.totalMoney") }}</div>
          <div class="value">$1 600.00</div>
        </div>
      </div>
    </div>
    <!-- 看图下单 -->
    <div v-if="detailsType == 'picture'">
      <!-- 看图下单详情 -->
      <div class="picture-details">
        <!-- <div class="detail-msg-title">{{ $t("order.checkOptions") }}</div> -->
        <div class="picture-product-name">
          {{ $t("order.basicInformation") }} &nbsp;&nbsp;&nbsp;<a
          class="no-print"
          @click="print"
        >Export PDF</a
        >
        </div>
        <div class="common-flex common-flex-wrap">
          <!--           <div> Order No.{{ config.orderCode }}</div>
                     <div>  {{ $t("order.style") }}: {{ config.styleName }} </div>
                     <div>  {{ $t("order.style") }}: {{config.orderName }} </div>-->
          <div class="r-details-ipt common-flex common-justify-between">
            <div style="opacity: 0.7">Order No.</div>
            <div>{{ config.orderCode }}</div>
          </div>
          <div class="r-details-ipt common-flex common-justify-between">
            <div style="opacity: 0.7">Order Type</div>
            <div>{{ config.orderName }}</div>
          </div>
          <div class="r-details-ipt common-flex common-justify-between">
            <div style="opacity: 0.7">Category</div>
            <div>{{ config.clothZhName }}</div>
          </div>
          <div class="r-details-ipt common-flex common-justify-between">
            <div style="opacity: 0.7">Fabric No.</div>
            <div>{{ config.fabric }}</div>
          </div>
          <div class="r-details-ipt common-flex common-justify-between">
            <div style="opacity: 0.7">Order Date</div>
            <div>{{ config.pubDate }}</div>
          </div>
          <div class="r-details-ipt common-flex common-justify-between">
            <div style="opacity: 0.7">Size Category</div>
            <div>{{ config.sizeCategoryName }}</div>
          </div>
          <div class="r-details-ipt common-flex common-justify-between">
            <div style="opacity: 0.7">Quantity</div>
            <div>{{ config.amount }}</div>
          </div>
          <div class="r-details-ipt common-flex common-justify-between">
            <div style="opacity: 0.7">Status</div>
            <div>{{ config.statusName }}</div>
          </div>
          <div
            class="r-details-ipt common-flex common-justify-between"
            style="width: 90%"
          >
            <div style="opacity: 0.7">Order Note</div>
            <div>{{ config.flInfo }}{{ config.remark }}</div>
          </div>
        </div>
        <div
          class="picture-product"
          v-for="(item, index) in filteredOrderDetails"
          :key="index"
        >
          <div class="picture-product-name">
            {{ item.clothName }} {{ $t("cart.jeansCrafts") }}
            <span v-if="item.styleInfoName"> - {{ item.styleInfoName }}</span>
            <span v-if="item.styleInfoCode"> - {{ item.styleInfoCode }}</span>
          </div>
          <div
            style="margin: 15px 0 30px 0"
            class="common-flex common-flex-wrap"
          >
            <div
              class="picture-img-box"
              v-for="(citem, cindex) in item.orderCraftList"
              :key="cindex"
            >
              <template v-if="citem.url">
                <div class="picture-img-wrap">
                  <rImgNone :img="citem.craftUrl"></rImgNone>
                  <div class="price" v-if="citem.price">{{ citem.price }}</div>
                </div>
                <div class="right-content">
                  <Tooltip
                    :content="(citem.parentName?(citem.parentName + ': '):'') + citem.craftName"
                    placement="top"
                    max-width="100"
                  >
                    <div class="craft-name">
                      <span v-if="config.orderType!==7&&citem.blEcode" class="craft-code">{{ citem.blEcode }}</span>
                      {{ citem.craftName }}
                    </div>
                  </Tooltip>
                  <div v-if="citem.parentName || citem.content" class="craft-content">
                    <template v-if="citem.parentName">{{ citem.parentName }}:</template>
                    {{ citem.content }}
                  </div>
                </div>
                <div class="picture-item-code">
                  <a :href="citem.url" download="">{{
                      citem.url | filterCraftUrl
                    }}</a>
                </div>
              </template>
              <template v-else>
                <div class="picture-img-wrap">
                  <rImgNone :img="citem.craftUrl"></rImgNone>
                  <div class="price" v-if="citem.price">{{ citem.price }}</div>
                </div>
                <div class="right-content">
                  <Tooltip
                    :content="(citem.parentName?(citem.parentName + ': '):'') + citem.craftName"
                    placement="top"
                    max-width="700"
                  >
                    <div class="craft-name">
                      <span v-if="config.orderType!==7&&citem.blEcode" class="craft-code">{{ citem.blEcode }}</span>
                      <template v-if="citem.parentName">{{ citem.parentName }}:</template>
                      {{ citem.craftName }}
                    </div>
                  </Tooltip>
                  <div v-if="citem.content" class="craft-content">
                    {{ citem.content }}
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <!-- 看图下单对应的图 -->
      <div
        class="monogram"
        v-for="(item, index) in filteredEmbOrderDetails"
        :key="index"
      >
        <div class="picture-product-name" style="margin: 10px 0">
          {{ item.clothName }}
        </div>
        <div
          class="common-flex common-flex-wrap"
          style="margin: 15px 15px 25px 0"
        >
          <div
            v-for="(citem, cindex) in item.orderEmbList"
            :key="cindex"
            class="monogram-item common-flex common-justify-between"
          >
            <div>
              <div class="monogram-item-title">
                {{ $t("cart.monogram") }} {{ cindex + 1 }}
              </div>
              <div class="monogram-item-line common-flex common-align-center">
                <div class="title">{{ $t("cart.position") }}</div>
                <div class="content">{{ citem.site }}</div>
              </div>
              <div class="monogram-item-line common-flex common-align-center">
                <div class="title">{{ $t("cart.threadNumber") }}</div>
                <div class="content">{{ citem.color }}</div>
              </div>
              <div
                v-if="citem.embSize"
                class="monogram-item-line common-flex common-align-center"
              >
                <div class="title">Size</div>
                <div class="content">{{ citem.embSize }}</div>
              </div>
              <div class="monogram-item-line common-flex common-align-center">
                <div class="title">{{ $t("cart.font") }}</div>
                <div class="content">{{ citem.font }}</div>
              </div>
              <template v-if="citem.embUrl">
                <div class="monogram-item-line common-flex common-align-center">
                  <div class="title">附件</div>
                  <div class="content">
                    <a :href="citem.embUrl" download="">{{
                        citem.embFileName
                      }}</a>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="monogram-item-line common-flex common-align-center">
                  <div class="title">{{ $t("cart.content") }}</div>
                  <div class="content">{{ citem.embContent }}</div>
                </div>
              </template>
            </div>
            <div>
              <img
                style="width: 130px; height: 130px"
                src="../assets/images/emb-none.png"
                alt=""
              />
              <div
                style="width: 130px; text-align: center; color: #0a4dcc"
                v-if="citem.embPrice"
              >
                {{ citem.embPrice }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="picture-product-name" style="margin-bottom: 0">
        {{ config.sizeCategoryName }}
        <span v-if="config.sizeAreaName">{{ config.sizeAreaName }}</span>
      </div>
      <div v-for="(allitem, allindex) in config.orderDetails" :key="allindex">
        <div class="common-flex common-align-center">
          <div class="picture-product-name">
            {{ allitem.clothName }}{{ $t("cart.size") }}
          </div>
          <div style="margin: 25px 0 15px 10px" v-if="allitem.shape">
            ({{ allitem.shape }})
          </div>
        </div>
        <div v-if="allitem.styleName">
          Dressing Style: {{ allitem.styleName }}
        </div>
        <div class="common-flex common-flex-wrap">
          <rDetailsIpt
            v-for="(item, index) in allitem.customerSize"
            :key="index"
            :config="item"
          ></rDetailsIpt>
        </div>
      </div>
    </div>
    <div>
      <div
        v-if="config.orderGoods"
        class="monogram-item-big common-flex common-justify-between"
      >
        <div>
          <div class="monogram-item-title">{{ config.orderGoods.goodName }}</div>
          <div class="common-flex common-flex-wrap">
            <div class="monogram-item-line common-flex common-align-center">
              <div class="title">{{ $t("underProduction.categoryName") }}</div>
              <div class="content">{{ config.orderGoods.categoryName }}</div>
            </div>
            <!-- <div class="monogram-item-line common-flex common-align-center">
              <div class="title">{{ $t("underProduction.goodName") }}</div>
              <div class="content">{{config.orderGoods.goodName}}</div>
            </div> -->
            <div
              class="monogram-item-line common-flex common-align-center"
            >
              <div class="title">{{ $t("underProduction.goodSku") }}</div>
              <div class="content">{{ config.orderGoods.goodSku }}</div>
            </div>
            <div
              class="monogram-item-line common-flex common-align-center"
            >
              <div class="title">{{ $t("underProduction.price") }}</div>
              <div class="content">{{ config.orderGoods.price }}</div>
            </div>
            <div
              class="monogram-item-line common-flex common-align-center"
            >
              <div class="title">{{ $t("underProduction.amount") }}</div>
              <div class="content">{{ config.orderGoods.amount }}</div>
            </div>
            <div
              v-if="config.orderGoods.spec"
              class="monogram-item-line common-flex common-align-center"
            >
              <div class="title">{{ $t("underProduction.spec") }}</div>
              <div class="content">{{ config.orderGoods.spec }}</div>
            </div>
            <div
              v-if="config.orderGoods.color"
              class="monogram-item-line common-flex common-align-center"
            >
              <div class="title">{{ $t("underProduction.color") }}</div>
              <div class="content">{{ config.orderGoods.color }}</div>
            </div>
            <!--          <div-->
            <!--            class="monogram-item-line common-flex common-align-center"-->
            <!--          >-->
            <!--            <div class="title">{{ $t("underProduction.deliveryDays") }}</div>-->
            <!--            <div class="content">{{config.orderGoods.deliveryDays}}</div>-->
            <!--          </div>-->
          </div>
        </div>
        <div>
          <img
            :src="config.orderGoods.images.split(',')[0]"
            alt=""
            class="monogram-item-big-img"
          />
          <!-- <div style="width: 130px; text-align: center; color: #0a4dcc">5</div> -->
        </div>
      </div>
    </div>
    <!-- 代码下单 -->
    <div v-if="detailsType == 'code'" class="code-order">
      <div class="detail-msg-title">{{ $t("order.checkOptions") }}</div>
      <!-- 填写代码 -->
      <div>
        <div class="picture-product-name">Jeans Crafts</div>
        <div
          class="code-details common-flex common-justify-between common-flex-wrap"
        >
          <div class="common-flex" v-for="index in 4" :key="index">
            <div class="code-details-code">ASDA</div>
            <div class="code-details-content">
              <div>
                Lapel buttonhole Thread-Appointed Color:button thread
                color-lapel:customer appointed
              </div>
              <div class="ipt-msg">123</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 刺绣位置 -->
      <div>
        <!-- orderDetails -->
        <div class="picture-product-name">{{ $t("cart.monogram") }}</div>
        <div
          v-for="index in 2"
          :key="index"
          style="
            border-bottom: 1px solid #e6e8eb;
            padding-bottom: 25px;
            margin-top: 25px;
          "
          class="code-details common-flex common-justify-between common-flex-wrap"
        >
          <div class="common-flex" v-for="(item, index) in embs" :key="index">
            <div class="code-details-code" style="width: 120px">
              {{ item.name }}
            </div>
            <div class="code-details-content" style="width: 426px">
              <div>{{ item.label }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!config.orderGoods">
      <div class="detail-msg-title" style="margin: 40px 0 25px">
        {{ $t("order.customerInformation") }}
      </div>
      <div class="picture-product-name">{{ $t("order.basicInformation") }}</div>
      <div class="common-flex common-flex-wrap">
        <rDetailsIpt
          v-for="(item, index) in basicList"
          :key="index"
          :config="item"
        ></rDetailsIpt>
        <!-- <div class="r-details-ipt common-flex common-justify-between" style="width:545px">
          <div style="opacity:.7">Address</div>
          <div>3050 Bowers Avenue P.O. Box 58039 Santa Clara, CA 95054-3299 U.S.A.</div>
        </div> -->
      </div>
    </div>
    <div class="picture-product-name" v-if="dressStyle.length > 0">
      Body shape info.
    </div>
    <div class="common-flex common-flex-wrap">
      <rDetailsIpt
        v-for="(item, index) in dressStyle"
        :key="index"
        :config="item"
      ></rDetailsIpt>
    </div>
  </div>
</template>

<script>
import rDetailsIpt from "./r-details-ipt";
import rImgNone from "./r-img-none";
import html2canvas from "html2canvas";
import JsPDF from "jspdf";

export default {
  name: "r-order-details",
  components: {
    rDetailsIpt,
    rImgNone,
  },
  props: {
    hideStep: {
      type: Boolean,
      default: false,
    },
    detailsType: String,
    config: [Object, String],
  },
  filters: {
    filterCraftUrl: function (url) {
      let index = url.lastIndexOf("/");
      let craftUrl = url.substring(index + 1);
      return craftUrl;
    },
  },
  computed: {
    filteredOrderDetails() {
      return this.config.orderDetails.filter(item => item.orderCraftList.length > 0);
    },
    filteredEmbOrderDetails() {
      return this.config.orderDetails.filter(item => item.orderEmbList.length > 0);
    }
  },
  watch: {
    config: {
      handler(newval, oldval) {
        console.log("newval", newval);
        if (newval) {
          this.basicList[0].value = newval.customer.custName || " ";
          this.basicList[1].value =
            newval.customer.height + " " + newval.customer.heightUnitName;
          this.basicList[2].value =
            newval.customer.weight + " " + newval.customer.weightUnitName;
          this.basicList[3].value = newval.customer.genderName || " ";
          this.basicList[4].value = newval.customer.cusOrderCode || " ";
          this.basicList[5].value = newval.customer.phone || " ";
          this.basicList[6].value = newval.customer.email || " ";
          this.basicList[7].value = newval.customer.birthdate || " ";
          // this.basicList[8].value = newval.customer.address || " ";
          newval.orderDetails.map((item) => {
            item.customerSize.map((citem) => {
              citem.label = citem.partName;
              if (citem.partSize) {
                citem.value =
                  citem.partSize + " " + newval.customer.heightUnitName;
              } else {
                citem.value = " " + " " + newval.customer.heightUnitName;
              }
            });
          });
          if (newval.customerSpecial && newval.customerSpecial.length > 0) {
            newval.customerSpecial.map((item) => {
              item.label = item.desName;
              item.value = item.specName;
            });
            this.dressStyle = newval.customerSpecial;
            console.log("this.dressStyle", this.dressStyle);
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    print() {
      let fileName = this.config.orderCode;
      let myBox = this.$refs.printMe; //获取ref里面的内容
      html2canvas(myBox, {
        useCORS: true, //是否尝试使用CORS从服务器加载图像
        allowTaint: true,
        dpi: 300, //解决生产图片模糊
        scale: 3, //清晰度--放大倍数
      }).then(function (canvas) {
        let contentWidth = canvas.width;
        let contentHeight = canvas.height;
        let pageHeight = (contentWidth / 592.28) * 841.89; // 一页pdf显示html页面生成的canvas高度;
        let leftHeight = contentHeight; //未生成pdf的html页面高度
        let position = 0; //pdf页面偏移
        //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
        // let imgWidth = 595.28
        let imgWidth = 560.28; //宽度
        let imgHeight = (592.28 / contentWidth) * contentHeight;
        let pageData = canvas.toDataURL("image/jpeg", 1.0);
        let PDF = new JsPDF("", "pt", "a4");

        // 有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
        //当内容未超过pdf一页显示的范围，无需分页
        if (leftHeight < pageHeight) {
          PDF.addImage(pageData, "JPEG", 20, 20, imgWidth, imgHeight);
        } else {
          while (leftHeight > 0) {
            PDF.addImage(pageData, "JPEG", 20, position, imgWidth, imgHeight);
            leftHeight -= pageHeight;
            position -= 841.89;
            if (leftHeight > 0) {
              PDF.addPage();
            }
          }
        }
        PDF.save(fileName + ".pdf"); //下载标题
      });
    },
  },
  data() {
    return {
      // 特体信息
      dressStyle: [
        // {
        //   label:'Stomach',
        //   value:'Normal'
        // },
      ],
      // 基本信息
      basicList: [
        {
          label: "Name",
          value: "Corey Jordan",
        },
        {
          label: "Height",
          value: "160 Inch",
        },
        {
          label: "Weight",
          value: "50 Lbs",
        },
        {
          label: "Gender",
          value: "Female",
        },
        {
          label: "Order#",
          value: "123456432",
        },
        {
          label: "Phone#",
          value: "18877226653",
        },
        {
          label: "Email",
          value: "122756776@163.com",
        },
        {
          label: "DOB",
          value: "09/10/2020",
        },
      ],
      // 刺绣列表
      embs: [
        {
          name: "Position:",
          label:
            "(standing collar) embroidery at the center of the left front collar (1.0 away from the front end， the embroidery at this position is incorrect， the customer accepts this effect)",
        },
        {
          name: "Content:",
          label: "liwenli",
        },
        {
          name: "Thread Number:",
          label: "1034#-Dark pink",
        },
        {
          name: "Font:",
          label: "RC06 Bank Gothic Light BT",
        },
      ],
      // 类型
      // type:'picture',
      // 当前步骤
      stepId: 3,
      step: [
        {
          name: "place an order",
          value: "09:00:02 01/20/2021",
          id: 1,
        },
        {
          name: "Product",
          value: "09:00:02 01/20/2021",
          id: 2,
        },
        {
          name: "Under Production",
          value: "09:00:02 01/20/2021",
          id: 3,
        },
        {
          name: "Complete",
          value: "09:00:02 01/20/2021",
          id: 4,
        },
      ],
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.picture-img-box {
  position: relative;
  width: 280px;
  margin: 0 12px 8px 0;
  padding: 8px;
  border: 1px solid #e6e8eb;
  border-radius: 3px;
  transition: all 0.2s ease;

  .picture-img-price {
    position: absolute;
    top: 8px;
    right: 8px;
    padding: 0 6px;
    height: 18px;
    background: #0a4dcc;
    border-radius: 2px;
    font-size: 12px;
    color: #ffffff;
    line-height: 18px;
    z-index: 1;
  }

  &:hover {
    box-shadow: 0 1px 6px rgba(10, 77, 204, 0.08);
  }

  .picture-img-wrap {
    position: relative;
    width: auto; /* Auto adjusts the width */
    height: 100px; /* Fixed height */
    background: #f8f9fa;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    float: left;
    margin-right: 12px;
    overflow: hidden;

    .price {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 4px;
      margin: 0 auto;
      width: fit-content;
      min-width: 50px;
      padding: 0 6px;
      height: 18px;
      background: #0a4dcc;
      border-radius: 2px;
      font-size: 12px;
      color: #ffffff;
      line-height: 18px;
      text-align: center;
    }

    .picture-img-wrap img {
      width: auto; /* Auto adjusts the width based on the height */
      height: 100%; /* Ensures the image respects the fixed height */
      object-fit: contain; /* Maintains the aspect ratio */
    }
  }

  .right-content {
    overflow: hidden;

    .craft-name {
      font-size: 12px;
      color: #081938;
      line-height: 16px;
      height: 32px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      word-break: break-all;

      .craft-code {
        color: #0a4dcc;
        margin-right: 4px;
      }
    }

    .craft-content {
      font-size: 12px;
      color: #666666;
      line-height: 16px;
      height: 32px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      word-break: break-all;
      background: #f8f9fa;
      padding: 6px 8px;
      border-radius: 2px;
      margin-top: 4px;
    }
  }
}

.r-order-details {
  padding-left: 80px;
  background: #fff;
  margin: 0 auto;

  .r-details-ipt {
    width: 250px;
    padding: 12px 0;
    border-bottom: 1px solid #d9dce1;
    font-size: 14px;
    font-family: Roboto, Roboto-Regular;
    font-weight: 400;
    text-align: right;
    color: #081938;
    line-height: 16px;
    margin-top: 13px;
    margin-right: 45px;
  }

  .steps {
    margin: 0 auto 113px;
  }

  .step-radio {
    width: 36px;
    height: 36px;
    background: #e6edf9;
    border-radius: 50%;
    line-height: 36px;
    text-align: center;
    font-size: 14px;
    color: #0a4dcc;
    position: relative;

    .step-status {
      position: absolute;
      top: 46px;
      width: 150px;
      left: -57px;
      // left: 0;
      // right: 0;
      // margin-right: auto;
      // margin-left: auto;
    }
  }

  .step-name {
    font-size: 14px;
    font-family: Roboto, Roboto-Regular;
    font-weight: 400;
    text-align: center;
    color: #081938;
    line-height: 16px;
    margin-bottom: 8px;
  }

  .step-value {
    opacity: 0.4;
    font-size: 12px;
    font-family: Roboto, Roboto-Regular;
    font-weight: 400;
    text-align: center;
    color: #081938;
    line-height: 14px;
  }

  .step-radio-check {
    position: absolute;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: #0a4dcc;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    color: #fff;
    line-height: 28px;
  }

  .step-line {
    width: 121px;
    height: 4px;
    background: #e6edf9;
    margin: 0 -4px;
    position: relative;
    z-index: 9;
  }

  .detail-msg-title {
    opacity: 0.4;
    font-size: 16px;
    font-family: Roboto, Roboto-BoldCondensed;
    font-weight: BoldCondensed;
    text-align: left;
    color: #081938;
    line-height: 19px;
  }

  .detail-msg {
    margin: 0 auto 40px;

    > div {
      width: 420px;
      padding: 0 40px;
      border-right: 1px solid #eaeaea;
    }

    .detail-content {
      align-items: center;
      margin-top: 25px;

      .label {
        word-wrap: break-word;
        font-size: 14px;
        font-family: Roboto, Roboto-Condensed;
        font-weight: Condensed;
        text-align: left;
        color: #081938;
        line-height: 16px;
        letter-spacing: 1px;
      }

      .value {
        max-width: 230px;
        text-align: right;
        word-wrap: break-word;
        opacity: 1;
        font-size: 14px;
        font-family: Roboto;
        font-weight: Condensed;
        text-align: right;
        color: #081938;
        line-height: 22px;
        // letter-spacing: 1px;
      }
    }
  }

  .picture-product-name {
    font-size: 14px;
    font-family: Roboto;
    font-weight: 600;
    text-align: left;
    color: #081938;
    line-height: 16px;
    margin: 25px 0 15px;
  }

  // 看图下单
  .picture-details {
    .picture-product {
      margin-top: 12px;

      .picture-img-box {
        width: 280px;
        margin: 0 12px 8px 0;
        padding: 8px;
        border: 1px solid #e6e8eb;
        border-radius: 3px;
        transition: all 0.2s ease;

        &:hover {
          box-shadow: 0 1px 6px rgba(10, 77, 204, 0.08);
        }

        .picture-img-wrap {
          position: relative;
          width: 80px;
          height: 80px;
          background: #f8f9fa;
          border-radius: 2px;
          display: flex;
          align-items: center;
          justify-content: center;
          float: left;
          margin-right: 12px;

          .price {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 4px;
            margin: 0 auto;
            width: fit-content;
            min-width: 50px;
            padding: 0 6px;
            height: 18px;
            background: #0a4dcc;
            border-radius: 2px;
            font-size: 12px;
            color: #ffffff;
            line-height: 18px;
            text-align: center;
          }
        }

        .right-content {
          overflow: hidden;

          .craft-name {
            font-size: 12px;
            color: #081938;
            line-height: 16px;
            height: 32px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            word-break: break-all;

            .craft-code {
              color: #0a4dcc;
              margin-right: 4px;
            }
          }

          .craft-content {
            font-size: 12px;
            color: #666666;
            line-height: 16px;
            height: 32px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            word-break: break-all;
            background: #f8f9fa;
            padding: 6px 8px;
            border-radius: 2px;
            margin-top: 4px;
          }
        }
      }

      .common-flex {
        flex-wrap: wrap;
        margin-right: -12px;
      }
    }
  }

  .monogram {
    .monogram-item {
      width: 484px;
      // height: 170px;
      margin-top: 15px;
      padding: 20px;
      border: 1px dashed rgba(8, 25, 56, 0.3);
      margin-right: 15px;

      .monogram-item-title {
        font-size: 14px;
        font-family: Roboto;
        font-weight: 400;
        text-align: left;
        color: #081938;
        line-height: 16px;
      }

      .monogram-item-line {
        margin-top: 15px;
        font-size: 12px;
        font-family: Roboto, Roboto-Regular;
        font-weight: 400;
        text-align: center;
        color: #081938;
        word-wrap: break-word;
        line-height: 14px;
        text-align: left;

        .title {
          opacity: 0.7;
          width: 114px;
          word-wrap: break-word;
        }

        .content {
          width: 200px;
        }
      }
    }
  }

  .monogram-item-big {
    margin: 0 80px 0 0;
    // width: 484px;
    // height: 170px;
    margin-top: 15px;
    padding: 20px;
    border: 1px dashed rgba(8, 25, 56, 0.3);
    margin-right: 15px;
    // width: calc(100% - 160px);
    width: 90%;
    // align-items: center;
    .monogram-item-big-img {
      width: 300px;
      // height: 300px;
    }

    .monogram-item-title {
      font-size: 14px;
      font-family: Roboto;
      font-weight: 400;
      text-align: left;
      color: #081938;
      line-height: 16px;
    }

    .monogram-item-line {
      margin-top: 15px;
      font-size: 12px;
      font-family: Roboto, Roboto-Regular;
      font-weight: 400;
      text-align: center;
      color: #081938;
      word-wrap: break-word;
      line-height: 14px;
      text-align: left;

      .title {
        opacity: 0.7;
        width: 114px;
        word-wrap: break-word;
      }

      .content {
        width: 200px;
      }
    }
  }

  .code-order {
    width: 1136px;

    .code-details {
      > div {
        width: 568px;
        margin-bottom: 10px;
      }

      .code-details-code {
        font-size: 14px;
        font-family: Roboto, Roboto-Regular;
        font-weight: 400;
        text-align: left;
        color: #081938;
        line-height: 16px;
        margin-right: 8px;
        word-wrap: break-word;
      }

      .code-details-content {
        opacity: 0.7;
        font-size: 14px;
        font-family: Roboto, Roboto-Regular;
        font-weight: 400;
        text-align: left;
        color: #081938;
        line-height: 16px;
        word-wrap: break-word;

        .ipt-msg {
          width: 320px;
          height: 20px;
          opacity: 1;
          background: #f8f8f8;
          border-radius: 4px;
          padding: 3px 7px;
          margin-top: 4px;
        }
      }
    }
  }
}

@media print {
  .no-print {
    display: none;
  }

  @page {
    size: A3;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/r-order-details.vue